import Raven from 'raven-js';

export default function reportError(error: Error, data: Object = {}) {
  if (process.env.NODE_ENV === 'development') {
    console.error(error, data);
  }
  if (process.env.NODE_ENV === 'production') {
    Raven.captureException(error, { extra: data });
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/services/reportError.js